import { Route, RouteProps, Routes } from 'react-router';
import TopNavBar from '../components/TopNavBar';
import * as Style from '../dashboard/main/style';
import { Profile } from '../dashboard';
import AdminDashboard from '../dashboard/multitier/AdminDashboard';
import LearningRoutes from './LearningRoutes';
import { useLmsEnabled } from '../hooks/useLmsPermission';

const DrillDownRoutes: React.FC<RouteProps> = () => {
  const lmsPermission = useLmsEnabled();

  return (
    <Style.MainWrapper>
      <Style.MainLayout>
        <TopNavBar hideCompanyLogo useDrillDownCrumbs />
        <Style.MainSection>
          <Style.MainContentRight>
            <Routes>
              <Route path='/choose-group' element={<AdminDashboard />} />
              <Route path='/choose-organization' element={<AdminDashboard />} />
              <Route path='/choose-team' element={<AdminDashboard />} />
              <Route path='/courses/*' element={lmsPermission ? <LearningRoutes /> : undefined} />
              <Route path='/profile' element={<Profile />} />
            </Routes>
          </Style.MainContentRight>
        </Style.MainSection>
      </Style.MainLayout>
    </Style.MainWrapper>
  );
};

export default DrillDownRoutes;
